import styled from "styled-components"

type Props = {
  theme: string,
  secondColor?: string,
}

const ContainedButton = styled.a<Props>`
  background: ${props => props.secondColor ? `linear-gradient(125deg, ${props.secondColor} 0%,${props.secondColor} 40%,${props.theme} 41%,${props.theme} 100%)` : props.theme};
  padding: 1rem 3rem calc(1rem - 5px) 3rem;
  text-decoration: none;
  text-align: center;
  font-size: 1.625rem;
  font-weight: 500;
  margin: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  text-transform: uppercase;
  cursor: pointer;
  :hover{
    filter: brightness(85%);
  }
  
`



export default ContainedButton